// extracted by mini-css-extract-plugin
module.exports = {"product_description":"MainLayout_product_description__XRsRI","main_container":"MainLayout_main_container__HR_04","fadeMe":"MainLayout_fadeMe__XZxtN"};